import { render, staticRenderFns } from "./TabInventory.vue?vue&type=template&id=5cd5e8ba"
import script from "./TabInventory.vue?vue&type=script&lang=ts"
export * from "./TabInventory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports